import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/OrderPlannerProducts';
import './OrderPlannerProducts.css';
import { Button, Modal } from 'react-bootstrap';
import ReactTable from "../react-table/src/index";
import StarRatingComponent from 'react-star-rating-component';
import ResetOrderPlannerDataButton from '../common/ResetOrderPlannerData';
import { confirmAlert } from 'react-confirm-alert';
import _ from 'lodash';
import { FcCalculator } from "react-icons/fc";

import 'react-confirm-alert/src/react-confirm-alert.css'; 
import 'font-awesome/css/font-awesome.min.css';
import "../react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";

import treeTableHOC from "../react-table/src/hoc/treeTable";

// wrap ReactTable in it
// the HOC provides the configuration for the TreeTable
const TreeTable = treeTableHOC(ReactTable);

class OrderPlannerProducts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showDetails: false,
            showDetailsText: 'Details',
            mobileView: window.innerWidth < 768,
            tabletView: window.innerWidth <= 1254 && window.innerWidth >= 768,
            wideView: false,
            showMinMultModal: false,
            showNotEnoughQohToOrder: false,
            errorMessage: '',
            workingItemId: '',
            workingItemUM: '',
            windowWidth: window.innerWidth,
            showOrderQtyMoreThanQtyOnhand: false,
            expandedRows: this.props.expandedRows,
            showPriceCalc: localStorage.getItem('Menu-PriceCalc') === 'true' || localStorage.getItem('Menu-PriceCalc') === true,
            data: this.props.items,
            filteredProducts: this.props.items
        }

        this.filtering = false;

        this.onFilteredChange = this.onFilteredChange.bind(this);
        this.toggleShowDetails = this.toggleShowDetails.bind(this);
        this.setOrDeleteItemOrder = this.setOrDeleteItemOrder.bind(this);
        this.autoSetMinMult = this.autoSetMinMult.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.updateQuantityAutomatically = this.updateQuantityAutomatically.bind(this);
        this.selectFocus = this.selectFocus.bind(this);
    }

    onFilteredChange(e) {
        this.forceUpdate();
    }

    filterData(value) {
        let products = this.props.itemsBackup;
        var that = this;

        var filterValue = value.toLowerCase();
        console.log('value',value);

        if (products.length) {

            var newArray = products.filter(function (product) {
                console.log('Product Includes:', product.ItemId.toLowerCase().includes(filterValue));
                return product.ItemId.toLowerCase().includes(filterValue);
            });

            console.log('previous', products);
            console.log('new', newArray);

            return newArray;
        }

        return products;
    }


    // we need to try to keep everything expanded
    //shouldComponentUpdate(nextProps, nextState) {
    //    if (this.props.items[0] &&
    //        this.props.items[0].ThumbnailUrl === nextProps.items[0].ThumbnailUrl) {
    //        return false;
    //    } else {
    //        return true;
    //    }
    //}

    componentWillMount() {
        // This method runs when the component is first added to the page
        if (!localStorage.getItem('customer')) {
            window.open('/customer-search', '_self');
        } else if (!localStorage.getItem('orderPlannerContact')) {
            // Delivery information
            window.open('/order-planner-contact', '_self');

            return;
        } else if (localStorage.getItem('deliveryModeCode')
            && localStorage.getItem('deliveryModeDescription')
            && localStorage.getItem('badPO') !== "true"
            && localStorage.getItem('badPO') !== true)
        {
            if (localStorage.getItem('requirePO') === 'true' && !localStorage.getItem('orderPO')) {
                window.open('/order-planner-delivery', '_self');
            }

            this.props.history.push('/order-planner-products/');

            this.props.queryOrderPlannerItems();
        } else {
            window.open('/order-planner-delivery', '_self');

            return;
        }
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
        this.resize(true);
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize(true);
    }

    selectFocus(e) {
        e.target.select();
    }

    resize(skip) {
        // We only want to resize if the width changes so the Android 
        // keyboard doesn't disappear on inputs from the vertical height change
        if (window.innerWidth !== this.state.windowWidth || skip === true) {
            this.setState({ mobileView: window.innerWidth < 768 }, this.setState({ tabletView: window.innerWidth <= 1254 && window.innerWidth >= 768 }));
            this.setState({ wideView: window.innerWidth >= 1580 })
            this.setState({ windowWidth: window.innerWidth });
        }
    }

    handleDateChange(date) {
        this.props.selectDeliveryDate(date.toISOString().substring(0, 10));
    }

    updateQuantityAutomatically() {
        this.setState({ showMinMultModal: false });
    }

    handleClose(remove) {
        this.setState({ showMinMultModal: false });
        this.setState({ showNotEnoughQohToOrder: false });

        this.setState({ error: '' });
        
        if (remove === true) {
            console.log('remove = true');
            var itemId = this.state.workingItemId;
            var itemUM = this.state.workingItemUM;

            console.log(itemId, itemUM);

            localStorage.removeItem('order:' + itemId + ',' + itemUM);

            this.setState({ workingItemId: '' });
            this.setState({ workingItemUM: '' });
        }
    }

    getValidationStatePO() {
        const length = this.state.value.length;
        //if (length > 10) return 'success';
        //else if (length > 5) return 'warning';
        if (this.props.requirePO && length === 0) return 'error';
        return null;
    }

    getValidationStateSpecialInstructions() {
        //const length = this.state.value.length;
        //if (length > 10) return 'success';
        //else if (length > 5) return 'warning';
        //else if (length > 0) return 'error';
        return null;
    }

    autoSetMinMult() {
        var orderQty = this.state.workingItemQty;
        var minQty = this.state.workingItemMinQty;
        var multQty = this.state.workingItemMultQty;

        if (orderQty < minQty) {
            orderQty = minQty;
        } else if (orderQty % multQty !== 0) {
            while (orderQty % multQty !== 0) {
                orderQty += 1;
            }
        }

        this.setState({ workingItemQty: orderQty });
    }

    setOrDeleteItemOrder(e) {
        var that = this;

        // set local storage to the itemId and the qty
        console.log('input variable', e.target);

        var array = e.target.name.split(',');

        var itemId = array[0];
        var itemUM = array[1];

        var status = array[2];
        var orderQty = Number(e.target.value);
        var qtyOnHand = Number(array[5]);
        var minQty = Number(array[3]);
        var multQty = Number(array[4]);
        multQty = multQty <= 0 ? 1 : multQty;
        var salesPrice = Number(array[6]);
        var salesCost = Number(array[7]);
        var description = array[8];
        var rate1Margin = array[9];
        var rate2Margin = array[10];
        var rate3Margin = array[11];

        if (orderQty <= 0) {
            e.target.value = 0;

            localStorage.removeItem('order:' + itemId + ',' + itemUM);
        } else {

            var discontinuedItem = status === "DI";
            //discontinuedItem = true; // debugging
            //qtyOnHand = 213; // debugging
            var error = '';

            if (discontinuedItem) {
                if (orderQty > qtyOnHand) {
                    console.log(' this is a discontinued item not meeting specs. ');
                    error = "Item Discontinued - Order quantity reduced to on-hand quantity of: " + qtyOnHand + ".";

                    orderQty = qtyOnHand;
                }

                //console.log(qtyOnHand, minQty, orderQty, multQty);

                if (qtyOnHand < minQty || qtyOnHand < multQty ) {
                    error = "There are not enough of this discontinued item in stock to meet the order minimum and/or multiple requirements. Minimum: "
                        + minQty + ". Multiple: " + multQty + ".";

                    that.setState({ errorMessage: error });
                    that.setState({ showNotEnoughQohToOrder: true });

                    e.target.value = 0;
                    localStorage.removeItem('order:' + itemId + ',' + itemUM);

                    return false;
                } else if (orderQty % multQty !== 0) {
                    error = error + " Your order qty: " + orderQty + " is not a multiple allowed qty: " + multQty;

                    that.setState({ workingItemId: itemId });
                    that.setState({ workingItemUM: itemUM });

                    that.setState({ errorMessage: error });
                    that.setState({ showMinMultModal: true });

                    while (orderQty % multQty !== 0 && orderQty > 0) {
                        orderQty = orderQty - 1;
                    }

                    e.target.value = orderQty;
                } else if (error !== '') {
                    that.setState({ errorMessage: error });
                    that.setState({ showOrderQtyMoreThanQtyOnhand: true });
                    
                    e.target.value = orderQty;
                }
            } else if (orderQty % multQty !== 0 && orderQty < minQty) {

                that.setState({ workingItemId: itemId});
                that.setState({ workingItemUM: itemUM });

                error = "Your order qty: " + orderQty + " must be a multiple of: " + multQty
                    + ". It must also be a minimum of " + minQty + ".";

                orderQty = minQty;

                if (minQty < multQty && orderQty < multQty) {
                    that.target.value = multQty;
                    orderQty = multQty;
                } else {
                    while (orderQty % multQty !== 0 && orderQty > minQty) {
                        orderQty = orderQty - 1;
                    }
                }

                e.target.value = orderQty;

                that.setState({ errorMessage: error });
                that.setState({ showMinMultModal: true });
            } else if (orderQty % multQty !== 0 && orderQty > minQty) {
                error = "Your order qty : " + orderQty + " is not a multiple allowed qty: " + multQty;

                if (minQty >= multQty) {
                    while (orderQty % multQty !== 0) {
                        orderQty = orderQty - 1;
                    }
                } else {
                    while (orderQty % multQty !== 0) {
                        orderQty = orderQty + 1;
                    }
                }

                e.target.value = orderQty;

                that.setState({ workingItemId: itemId });
                that.setState({ workingItemUM: itemUM });

                that.setState({ errorMessage: error });
                that.setState({ showNotEnoughQohToOrder: true });
            } else if (orderQty < minQty) {
                console.log('orderQty', orderQty);
                console.log('minQty', minQty);
                error = "Your order qty: " + orderQty + " is below the minimum qty: " + minQty + ".";

                // update the qty in a dialog
                // show error
                that.setState({ workingItemId: itemId });
                that.setState({ workingItemUM: itemUM });
                that.setState({ errorMessage: error });
                that.setState({ showMinMultModal: true });

                orderQty = minQty;
            }

            if (orderQty <= 0) {
                localStorage.removeItem('order:' + itemId + ',' + itemUM);
            } else {
                var backOrdered = orderQty > qtyOnHand ? orderQty - qtyOnHand : 0;
                
                localStorage.setItem('order:' + itemId + ',' + itemUM, orderQty + ',' + status + ',' + salesPrice + ',' + salesCost + ',' + backOrdered + ',' + description + ',' + rate1Margin + ',' + rate2Margin + ',' + rate3Margin + ',' + salesCost);
            }
        }
    }

    toggleShowDetails(e) {
        var currentState = this.state.showDetails;

        if (currentState === true) {
            this.setState({ showDetails: false });
            this.setState({ showDetailsText: "Details" });
        } else {
            this.setState({ showDetails: true });
            this.setState({ showDetailsText: "Details" });
        }
    }

    render() {

        const pivotBy = ['ItemGroup', 'ItemClass']
        return (
            <div style={this.state.mobileView === true ? { marginTop: '-30px' } : this.state.tabletView === true ? { marginTop: '-10px' } : { marginTop: '20px'} }>
                <p style={{ display: "inline", color: "#fff" }}>{window.innerWidth.toString()}</p><br />
                
                <TreeTable
                    defaultFilterMethod={(filter, row, column) => {
                        const id = filter.pivotId || filter.id;
                        return row[id] !== undefined
                            ? String(row[id])
                                .toLowerCase()
                                .includes(filter.value.toLowerCase())
                            : true;
                    }}
                    // this works but causes the freeze to not workdefaultFilterMethod
                    sorted={[
                        { 
                            id: 'ItemGroup',
                            desc: false
                        }, {
                            id: 'ItemClass',
                            desc: false
                        }, {
                            id: 'ItemDesc',
                            desc: false
                        }]}
                    //defaultExpanded={getExpandedPivotedIds(this.props.items, pivotBy)}
                    data={this.props.items}
                    loading={this.props.isLoading} // Display the loading overlay when we need it
                    onFetchData={this.fetchData} // Request new data when things change
                    filterable
                    onFilteredChange={this.onFilteredChange}
                    //style={{
                    //    height: "400px" // This will force the table body to overflow and scroll, since there is not enough room
                    //}}
                    defaultPageSize={1000}
                    freezeWhenExpanded={this.props.freezeWhenExpanded}
                    className="-striped -highlight"
                    pivotBy={pivotBy}
                    minRows={1}
                    expanded={this.props.expandedRows}
                    collapseOnDataChange={false}
                    collapseOnPageChange={false}
                    collapseOnSortingChange={false}
                    noDataText="No products found."
                    //onExpandedChange={(newExpanded, index) => {
                    //    console.log('new expanded', newExpanded, index);
                    //    if (newExpanded[index[0]] === false) {
                    //        newExpanded = { 0: false };
                    //    } else {
                    //        Object.keys(newExpanded).map((k) => {
                    //            newExpanded[k] = { 0: false };
                    //        });
                    //    }
                    //    this.props.setExpanded(newExpanded);
                    //}}
                    onExpandedChange={expanded => this.props.setExpanded(expanded)}
                    columns={[
                        {
                            accessor: "ItemGroup",
                            //expander: true,
                            show: false,
                            width: 0
                        },
                        {
                            accessor: "ItemClass",
                            //expander: true,
                            show: false,
                            width: 0
                        },
                        {
                            accessor: "Rate1Margin",
                            show: false
                        },
                        {
                            accessor: "Rate2Margin",
                            show: false
                        },
                        {
                            accessor: "Rate3Margin",
                            show: false
                        },
                        {
                            Header: "Image",
                            accessor: "ThumbnailUrl",
                            show: false,
                        },
                        {
                            Header: "Item",
                            accessor: "ItemId",
                            resizable: false,
                            width: this.state.mobileView === false && this.state.tabletView === false ? 260 : 100,
                            Cell: row => (
                                <div style={{ overflow: 'visible' }}>
                                    {/* Mobile View */}
                                    <div className={this.state.mobileView === true || this.state.tabletView === true ? '' : 'hidden'}>
                                        <b style={{ display: 'inline' }}> {row.row.ItemId}</b >
                                        <br />
                                        <p style={{ display: 'inline' }}>
                                            <b><a style={{ position: 'relative' }} href={'http://www.empirepaper.com/ItemDisplayF.aspx?ItemId=' + row.row.ItemId} target="_blank">{row.row.ItemDesc}</a></b>
                                        </p><br />
                                        <div
                                            style={{
                                                textAlign: 'center',
                                                float: 'left',
                                                width: '65px',
                                                height: '65px'
                                            }}
                                        >
                                            <img
                                                style={{marginRight: '8px'}}
                                                alt=''
                                                src={row.row.ThumbnailUrl} />

                                        </div>
                                        <div style={{maxHeight: '25px'}}>
                                            <b style={{ display: 'block', color: 'steelblue' }} className={this.state.tabletView === true ? 'hidden' : ''}>{row.row.ItemStatus} <span style={{ color: 'black' }}>|</span> {row.row.QtyOnHand} On Hand</b>
                                            <p className={this.state.tabletView === true ? '' : 'hidden'} style={{ height: '5px' }}></p>
                                            <b style={{ display: 'block', color: 'orange' }}>Last: {row.row.LastQty} {row.row.SalesUnit} <span style={{ color: 'black' }}>|</span> {row.row.LastPrice} <span style={{ color: 'black' }}>|</span> {row.row.DateLastSale}</b>
                                            <b style={{ display: 'block', textAlign: 'center', color: 'saddlebrown' }}>
                                                <span style={{ color: 'black' }}>Avg Mth: </span>
                                                {row.row.AvgMoQty}
                                                <span style={{ color: 'black' }}> | Ytd:</span> {row.row.YtdQty}
                                            </b>
                                            <div className={this.state.showDetails === true ? '' : 'hidden'}
                                                style={{ float: 'left' }}>
                                                <b style={{ color: 'black' }}>{row.row.PriceMethod}</b>
                                                &nbsp;
                                                <b style={{ color: 'goldenrod' }}>
                                                    {((row.row.SalesPrice - row.row.Cost) / row.row.SalesPrice * 100).toFixed(1)}%
                                                    <span style={{ color: 'black' }}> |</span> {row.row.Cost} {row.row.CostType}
                                                </b>
                                            </div>
                                        </div>
                                        <div style={{ float: 'left', clear: 'both', display: 'flex', height: '25px', marginTop: '10px' }}>
                                            <input style={{ width: '40px' }}
                                                onBlur={this.setOrDeleteItemOrder}
                                                onFocus={e => e.target.select()}
                                                name={row.row.ItemId + ','
                                                    + row.row.SalesUnit + ','
                                                    + row.row.ItemStatus + ','
                                                    + row.row.MinQty + ','
                                                    + row.row.MultQty + ','
                                                    + row.row.QtyOnHand + ','
                                                    + row.row.SalesPrice + ','
                                                    + row.row.Cost + ','
                                                    + row.row.ItemDesc.replace(',', '@').replace(',', '@').replace(',', '@') + ','
                                                    + row.row.Rate1Margin + ','
                                                    + row.row.Rate2Margin + ','
                                                    + row.row.Rate3Margin + ','
                                                }
                                                pattern="\d*"
                                                type="number"
                                                defaultValue={localStorage.getItem('order:' + row.row.ItemId + ',' + row.row.SalesUnit) === null ? '0' : localStorage.getItem('order:' + row.row.ItemId + ',' + row.row.SalesUnit).split(',')[0]}
                                            />
                                            <b>&nbsp; {row.row.SalesUnit} &nbsp;{row.row.SalesPrice} &nbsp;</b>
                                            <div id="mobileview-star-rating">
                                                <StarRatingComponent
                                                    name="rate1"
                                                    style={{ display: 'flex' }}
                                                    editing={false}
                                                    value={
                                                        row.row.Cost ?
                                                            (row.row.SalesPrice - row.row.Cost) / row.row.SalesPrice * 100
                                                                >= row.row.Rate3Margin ?
                                                                3
                                                                :
                                                                (row.row.SalesPrice - row.row.Cost) / row.row.SalesPrice * 100
                                                                    >= row.row.Rate2Margin ?
                                                                    2
                                                                    :
                                                                    (row.row.SalesPrice - row.row.Cost) / row.row.SalesPrice * 100
                                                                        >= row.row.Rate1Margin ?
                                                                        1
                                                                        :
                                                                        0
                                                            :
                                                            0
                                                    }
                                                    starCount={3}
                                                    starColor="#ffb400"
                                                    emptyStarColor="#ffb400"
                                                    renderStarIcon={(index, value) => {
                                                        return (
                                                            <span style={{ marginBottom: '-5px', display: 'block' }}>
                                                                <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} />
                                                            </span>
                                                        );
                                                    }}
                                                    renderStarIconHalf={() => {
                                                        return (
                                                            <span style={{ marginBottom: '-5px', display: 'block' }}>
                                                                <span style={{ position: 'absolute' }}><i className="fa fa-star-half-o" /></span>
                                                                <span><i className="fa fa-star-half-o" /></span>
                                                            </span>
                                                        );
                                                    }}
                                                />
                                                <span style={{ display: 'inline-block', cursor: 'pointer', marginLeft: '5px', zIndex: '999' }} className={this.state.showPriceCalc === true ? 'calculatorButton' : 'hidden'} onClick={() => {
                                                    localStorage.setItem('selectedProduct', row.row.ItemId);
                                                    localStorage.setItem('selectedProductUM', row.row.SalesUnit);

                                                    window.open('/pricing-calculator', '_self');
                                                }}>
                                                    <FcCalculator style={{ height: '24px', width: '24px' }} />
                                                </span>
                                            </div>
                                        </div>


                                    </div>

                                    {/* Desktop View */}
                                    <div className={this.state.mobileView === true || this.state.tabletView === true ? 'hidden' : ''}>
                                        <div
                                            style={{
                                                textAlign: 'center',
                                                float: 'left',
                                                width: '65px',
                                                height: '65px'
                                            }}
                                        >
                                            <img
                                                alt=''
                                                src={row.row.ThumbnailUrl} />

                                        </div>&nbsp;
                                        <b style={{ display: 'inline' }}> {row.row.ItemId}</b >
                                        <br />
                                        <input style={{ width: '40px', marginLeft: '3px' }}
                                            onBlur={this.setOrDeleteItemOrder}
                                            onFocus={e => e.target.select()}
                                            name={row.row.ItemId + ','
                                                + row.row.SalesUnit + ','
                                                + row.row.ItemStatus + ','
                                                + row.row.MinQty + ','
                                                + row.row.MultQty + ','
                                                + row.row.QtyOnHand + ','
                                                + row.row.SalesPrice + ','
                                                + row.row.Cost + ','
                                                + row.row.ItemDesc.replace(',', '~~').replace(',', '~~').replace(',', '~~').replace(',', '~~').replace(',', '~~') + ','
                                                + row.row.Rate1Margin + ','
                                                + row.row.Rate2Margin + ','
                                                + row.row.Rate3Margin
                                            }
                                            type="number"
                                            defaultValue={localStorage.getItem('order:' + row.row.ItemId + ',' + row.row.SalesUnit) === null ? '0' : localStorage.getItem('order:' + row.row.ItemId + ',' + row.row.SalesUnit).split(',')[0]} />
                                        <b>&nbsp; {row.row.SalesUnit} &nbsp;{row.row.SalesPrice} &nbsp;</b>

                                        <div id="desktop-view-stars" style={{ display: 'inline-flex', height: '25px' }}>
                                            <StarRatingComponent
                                                name="rate1"
                                                editing={false}
                                                value={
                                                    row.row.Cost ?
                                                        (row.row.SalesPrice - row.row.Cost) / row.row.SalesPrice * 100
                                                            >= row.row.Rate3Margin ?
                                                            3
                                                            :
                                                            (row.row.SalesPrice - row.row.Cost) / row.row.SalesPrice * 100
                                                                >= row.row.Rate2Margin ?
                                                                2
                                                                :
                                                                (row.row.SalesPrice - row.row.Cost) / row.row.SalesPrice * 100
                                                                    >= row.row.Rate1Margin ?
                                                                    1
                                                                    :
                                                                    0
                                                        :
                                                        0
                                                }
                                                starCount={3}
                                                starColor="#ffb400"
                                                emptyStarColor="#ffb400"
                                                renderStarIcon={(index, value) => {
                                                    return (
                                                        <span style={{ marginBottom: '-5px', display: 'block' }}>
                                                            <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} />
                                                        </span>
                                                    );
                                                }}
                                                renderStarIconHalf={() => {
                                                    return (
                                                        <span style={{ marginBottom: '-5px', display: 'block' }}>
                                                            <span style={{ position: 'absolute' }}><i className="fa fa-star-half-o" /></span>
                                                            <span><i className="fa fa-star-half-o" /></span>
                                                        </span>
                                                    );
                                                }}
                                            />
                                            <span style={{ display: 'inline-block', cursor: 'pointer', marginTop: '10px' }} className={this.state.showPriceCalc === true ? 'calculatorButton' : 'hidden'} onClick={() => {
                                                localStorage.setItem('selectedProduct', row.row.ItemId);
                                                localStorage.setItem('selectedProductUM', row.row.SalesUnit);

                                                window.open('/pricing-calculator', '_self');
                                            }}>
                                                <FcCalculator style={{height: '24px', width: '24px'}} />
                                            </span>
                                        </div>
                                        <div style={{ display: 'block', marginTop: '3px' }}
                                            className={this.state.showDetails === true ? '' : 'hidden'}
                                        >
                                            <b style={{ color: 'black' }}>{row.row.PriceMethod}</b>
                                            &nbsp;
                                            <b style={{ color: 'goldenrod' }}>
                                                <span style={{ color: 'black' }}>|</span> Margin: {((row.row.SalesPrice - row.row.Cost) / row.row.SalesPrice * 100).toFixed(1)}%
                                            <span style={{ color: 'black' }}> |</span> {row.row.Cost}
                                            </b>
                                            <b style={{ color: 'goldenrod' }}>
                                                &nbsp; {row.row.CostType}
                                            </b>
                                        </div>
                                    </div>

                                </div>
                            )

                        },
                        {
                            Header: "Description",
                            accessor: "ItemDesc",
                            width: this.state.mobileView === false && this.state.tabletView === false ? 250 : this.state.tabletView === true ? 200 : 180,
                            Cell: row => (
                                <div className={this.state.mobileView === true || this.state.tabletView === true ? 'hidden' : ''}>
                                    <b style={{ display: 'block', textAlign: 'center' }}><a href={'http://www.empirepaper.com/ItemDisplayF.aspx?ItemId=' + row.row.ItemId} target="_blank">{row.row.ItemDesc}</a></b>
                                    <b style={{ display: 'block', textAlign: 'center', color: 'saddlebrown' }}>
                                        <span style={{ color: 'black' }}>Avg Mth: </span>
                                        {row.row.AvgMoQty}
                                        <span style={{ color: 'black' }}> | Ytd:</span> {row.row.YtdQty}
                                    </b>
                                </div>
                            )
                        },
                        {
                            Header: "Status",
                            accessor: "ItemStatus",
                            width: 60,
                            show: this.state.tabletView === true || (this.state.mobileView === false && this.state.tabletView === false),
                            Cell: row => (
                                <div>
                                    <b style={{ display: 'block', textAlign: 'center', color: 'steelblue' }}>{row.row.ItemStatus}</b>
                                </div>
                            )
                        },
                        {
                            Header: "QoH",
                            accessor: "QtyOnHand",
                            width: 60,
                            show: this.state.tabletView === true || (this.state.mobileView === false && this.state.tabletView === false),
                            Cell: row => (
                                <div>
                                    <b style={{ display: 'block', textAlign: 'right', color: 'steelblue' }}>{row.row.QtyOnHand}</b>
                                </div>
                            )
                        },
                        {
                            Header: "Last Qty",
                            accessor: "LastQty",
                            resizable: false,
                            width: 75,
                            show: this.state.mobileView === false && this.state.tabletView === false,
                            Cell: row => (
                                <div>
                                    <b style={{ display: 'block', textAlign: 'right', color: 'orange' }}>{row.row.LastQty}</b>
                                </div>
                            )
                        },
                        {
                            Header: "Last Price",
                            accessor: "LastPrice",
                            resizable: false,
                            width: 75,
                            show: this.state.mobileView === false && this.state.tabletView === false,
                            Cell: row => (
                                <div>
                                    <b style={{ display: 'block', textAlign: 'right', color: 'orange' }}>{row.row.LastPrice}</b>
                                </div>
                            )
                        },
                        {
                            Header: "Last Sale",
                            accessor: "DateLastSale",
                            resizable: false,
                            width: 110,
                            show: this.state.mobileView === false && this.state.tabletView === false,
                            Cell: row => (
                                <div>
                                    <b style={{ display: 'block', textAlign: 'center', color: 'orange' }}>{row.row.DateLastSale}</b>
                                    
                                </div>
                            )
                        },
                        {
                            Header: "AvgMoQty",
                            accessor: "AvgMoQty",
                            show: false
                        },
                        {
                            Header: "YTD",
                            accessor: "YtdQty",
                            show: false
                        },
                        {
                            accessor: "SalesPrice",
                            show: false,
                        },
                        {
                            accessor: "Cost",
                            show: false,
                        },
                        {
                            accessor: "CostType",
                            show: false,
                        },
                        {
                            Header: "UM",
                            accessor: "SalesUnit",
                            show: false,
                        },
                        {
                            accessor: "PriceMethod",
                            show: false,
                        },
                        {
                            Header: "MinQty",
                            accessor: "MinQty",
                            show: this.state.wideView === true,
                            width: 75,
                            Cell: row => (
                                <div>
                                    <b style={{ display: 'block', textAlign: 'center', color: '#800080', textAlign: 'right' }}>{row.row.MinQty}</b>
                                </div>
                            )
                        },
                        {
                            Header: "MultQty",
                            accessor: "MultQty",
                            show: this.state.wideView === true,
                            width: 75,
                            Cell: row => (
                                <div>
                                    <b style={{ display: 'block', textAlign: 'center', color: '#800080', textAlign: 'right', marginRight: '10px' }}>{row.row.MultQty}</b>
                                </div>
                            )
                        }

                    ]}
                />

                <br />
                <div className="order-planner-products-buttons">
                    <ResetOrderPlannerDataButton />
                    <Button style={{ marginLeft: '15px' }}
                        onClick={() => {
                            window.open('/order-planner-delivery', '_self');
                        }}>
                        &laquo; Previous                                                                                                    
                    </Button>

                    <Button style={{ marginLeft: '10px' }}
                        onClick={this.toggleShowDetails}>{this.state.showDetailsText}</Button>                                                                                                                                                  

                    <Button style={{ marginLeft: '10px' }}
                        onClick={() => {
                            var hasItem = false;
                            for (var key in localStorage) {
                                if (key.includes('order:')) {
                                    hasItem = true;

                                    break;
                                }
                            }

                            if (hasItem === true) {
                                window.open('/order-planner-review', '_self');
                            } else {
                                confirmAlert({
                                    title: 'Error',
                                    message: 'You must add at least one product before continuing.',
                                    buttons: [
                                        {
                                            label: 'OK'
                                        }
                                    ]
                                });
                            }
                    }}>
                        Next &raquo;
                    </Button>
                </div>

                <Modal show={this.state.showMinMultModal} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h4>{this.state.errorMessage}</h4>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.updateQuantityAutomatically}>Set quantity automatically</Button>
                        <Button onClick={() => { this.handleClose(true) }}>Remove</Button>
                    </Modal.Footer>
                </Modal>
                
                <Modal show={this.state.showNotEnoughQohToOrder} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h4>{this.state.errorMessage}</h4>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleClose}>Close</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showOrderQtyMoreThanQtyOnhand} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h4>{this.state.errorMessage}</h4>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleClose}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default connect(
    state => state.orderPlannerProducts,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(OrderPlannerProducts);


// WEBPACK FOOTER //
// ./src/components/sales/OrderPlannerProducts.js